// eslint-disable-next-line import/no-namespace
import * as Sentry from '@sentry/react';
import handleError from './src/handleError';
import generateRandomId from './src/random-id';

const isUserError = function (error: unknown) {
  const errorCodes = [
    'BAD_USER_INPUT',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
  ];

  if (!error) return false;

  const { errors } = error as {
    errors?: { extensions?: { code?: string } }[];
  };

  return (
    Array.isArray(errors)
    && errors.length > 0
    && errors.every(
      ({ extensions = {} }) =>
        extensions.code !== undefined && errorCodes.includes(extensions.code),
    )
  );
};

const initSentry = function (
  dsn: string,
  { sampleRate = 0.25, ignoreErrors = [] } = {},
) {
  Sentry.init({
    dsn: `https://${dsn}`,
    environment: process.env.NODE_ENV,
    release: process.env.RELEASE_NAME,
    integrations: [
      Sentry.graphqlClientIntegration({
        endpoints: ['https://api.guuru.com'],
      }),
    ],
    sampleRate,
    ignoreErrors: [
      'ChunkLoadError',
      /AbortError/,
      /NS_ERROR_/,
      /ResizeObserver/,
      /QuotaExceededError/,
      /The project's quota for this operation has been exceeded/,
      /Quota exceeded for quota/,
      /database connection is closing/,
      /closed database/,
      /IDBDatabase/,
      /Indexed Database/,
      /timeout, interrupted connection or unreachable host/,
      /Network\s?[Ee]rror/,
      /NotFoundError/,
      /Non-Error promise rejection captured/,
      /InvalidStateError: Failed to start the audio device/,
      /Firebase: Error \(auth\/network-request-failed\)/,
      /Firebase: Error \(auth\/internal-error\)/,
      ...ignoreErrors,
    ],
    dataCollection: {
      userInfo: true,
      cookies: false,
      httpBodies: [],
      graphQL: { document: true, variables: true },
    },
    beforeSend(event, hint) {
      if (isUserError(hint.originalException)) return null;
      return event;
    },
  });
};

export { Sentry, initSentry, generateRandomId, handleError };
